import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	parentFieldLabel: {
		id: 'issue-create.modal.create-form.layout-renderer.field-renderer.parent-field-label',
		defaultMessage: 'Parent',
		description: 'Label for the field representing the parent of an issue',
	},
	parentFieldDescription: {
		id: 'issue-create.modal.create-form.layout-renderer.field-renderer.parent-field-description',
		defaultMessage: 'Choose a parent to assign this issue to',
		description: 'Description prompt of the field representing the parent of an issue',
	},
});
